var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-manage"},[_c('user-registration',{attrs:{"isBilingual":_vm.isBilingual,"languageType":_vm.languageType,"webinarOrSubjectId":_vm.webinarOrSubjectId,"signUpPageType":_vm.signUpPageType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }